import { Box } from "@mui/material";

function TextTruncate({ children, className = '', ...rest }) {
  
  return (
    <Box
      component="span"
      className={className}
      sx={{
        display: "block",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        ...rest
      }}>
      {children}
    </Box>
  );
};

export default TextTruncate;